import "./settingprofile.scss";
import SettingProfileHeader from "../../../components/settingprofileheader/SettingProfileHeader";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import useSettings from "../../../Hooks/useSettings";
import { Setting } from "../../../redux/settings/settingsSlice";
import Loading from "../../../components/LoadingPage/Loading";
import { DeleteConfModel } from "../../../components/DeleteConfModel/deleteConfModel";
import { selectCurrentUserId } from "../../../redux/auth/authSlice";
import { useAppSelector } from "../../../redux/hooks";
import { toggleClass } from "../../../utils/commonUtils";
import { useModulePermissions, PermissionIdentifier, PermissionModule } from "../../../utils/permissionUtils";

const SettingProfile = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [settingDetails, setSettingDetails] = useState<Setting>();
  const [showModal, setShowModal] = useState(false);
  const { getSettingsByIdAPI, getSettingsByIdLoading } = useSettings();
  const { deleteSettingAPI, deleteSettingLoading } = useSettings();
  const currentUserId = useAppSelector(selectCurrentUserId);

  useEffect(() => {
    getSettingsByIdAPI(id ?? "").then((res: Setting) => {
      if (res) {
        setSettingDetails(res);
      }
    });
  }, []);

  const deleteSetting = async () => {
    await deleteSettingAPI({
      id: settingDetails?.id,
      updatedBy: currentUserId ?? "",
    });
    toggleModal();
    navigate("/settings");
  };

  const toggleModal = () => {
    toggleClass();
    setShowModal(!showModal);
  };

  const isPermitted = useModulePermissions(PermissionModule.SETTINGS);
  const isDeletePermitted = isPermitted(PermissionIdentifier.DELETE_SETTINGS);

  return (
    <div className="profile-page-wrapper">
      {getSettingsByIdLoading || deleteSettingLoading ? <Loading /> : null}
      <SettingProfileHeader
        title={settingDetails?.settingName ?? "-"}
        id={id}
        toggleModal={toggleModal}
      />
      <div className="profile-detail-box-wrapper">
        <div className="profile-detail-box">
          <div className="profile-info-box">
            <label>Setting Name</label>
            <p>{settingDetails?.settingName ?? "-"}</p>
          </div>
          <div className="profile-info-box" style={settingDetails && settingDetails.settingValue.length > 50 ? { gridColumn: "span 2" } : {}}>
            <label>Setting Value</label>
            <p>
              {settingDetails && settingDetails.settingValue && settingDetails.settingValue.length > 50 ?
                <pre className="json-output" style={settingDetails && settingDetails.settingValue.length > 50 ? { height: "300px" } : {}}>
                  {JSON.stringify(JSON.parse(settingDetails.settingValue), null, 4)}
                </pre> : settingDetails?.settingValue ?? "-"}

            </p>
          </div>
          <div className="profile-info-box">
            <label>Category</label>
            <p>{settingDetails?.category ?? "-"}</p>
          </div>
          <div className="profile-info-box full-width">
            <label>Notes</label>
            <textarea
              value={settingDetails?.notes || ""}
              disabled={true}
              rows={3}
              style={{
                width: "100%",
                resize: "vertical",
                backgroundColor: "white",
                fontSize: "14px",
                color: "black",
              }}
            />
          </div>
          <div className="profile-info-box d-flex align-items-center">
            <label className="me-2">Active</label>
            <input type="checkbox" checked={settingDetails?.isActive} disabled={true}></input>
          </div>
        </div>
      </div>
      <DeleteConfModel
        showModal={showModal}
        toggleModal={toggleModal}
        deleteAction={deleteSetting}
        recordName={settingDetails?.settingName || ""}
        modelName={`setting`}
        isDeletePermitted={isDeletePermitted}
      />
    </div>
  );
};

export default SettingProfile;
